<!-- Declaração de Saúde -->
<div *ngIf="heMedSenior" class="tab-pane active show" id="tabValidacao" aria-labelledby="tabValidacao">
  <app-proposta-entidade-validacao-ds-foto
    (respostaEnvioImagem)="onRespostaEnvioImagem($event)"></app-proposta-entidade-validacao-ds-foto>
</div>

<ng-container *ngIf="!heMedSenior">
  <section class="row">
    <div class="col-12 espacamento-form-mobile">
      <div class="card card-form">
        <div class="latest-blog-loop bg-white">
          <!-- Área do beneficiário -->
          <ng-container *ngIf="!heColaborador">
            <mat-horizontal-stepper
              [selectedIndex]="getStepIndexFromEnum(stepper.selectedIndex)"
              [linear]="isLinear"
              #stepper>
              <!-- passo 5 - Carta de Orientação -->
              <mat-step [label]="'CARTA_ORIENTACAO ' + propostaEnum.CARTA_ORIENTACAO">
                <div class="card-header card-form-header mt-1">
                  <h4 class="form-section">
                    <b>CARTA DE ORIENTAÇÃO AO BENEFICIÁRIO</b>
                  </h4>
                  <div>
                    <section class="blank-page">
                      <div class="card container mt-3 document-container">
                        <div class="container__heading" style="padding: 15px">
                          <div class="wrapper container center-block">
                            <div>
                              <header class="row clearfix" style="border: none">
                                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center header">
                                  <div class="row">
                                    <div class="column wide">
                                      <!-- <img src="https://portal.geia.com.br/Content/ImagesProposta/DocumentoProposta/UnimedFesp/logo.png" style="max-width: 200px;display:inline-block;" class="Unimed Fesp unimedlogogeader img-responsive"> -->
                                      <img
                                        src="../../../../../assets/app-assets/images/documentos-header/unimed-fesp.png"
                                        style="max-width: 200px; display: inline-block"
                                        class="Unimed Fesp unimedlogogeader img-responsive" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-justify bodytimes">
                                  <div class="row">
                                    <div class="column widetxtNumProposta text-left" style="font-size: 16px">
                                      <div class="widetxtNumPropostaa">
                                        <b>Operadora:</b>
                                        UNIMED FESP
                                        <br />
                                        <b>CNPJ:</b>
                                        43.643.139/0001-66
                                        <br />
                                        <b>Nº de registro na ANS:</b>
                                        319996
                                        <br />
                                        <b>Site:</b>
                                        <a href="http://www.unimed.coop.br" target="_blank" rel="noopener noreferrer">
                                          http://www.unimed.coop.br
                                        </a>
                                        <br />
                                        <b>Tel.:</b>
                                        0800-772-3030
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </header>
                              <div class=" ">
                                <div class="row">
                                  <div class="colunas col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="row mt-5">
                                      <p>Prezado(a) Beneficiário(a),</p>
                                      <p>
                                        A Agência Nacional de Saúde Suplementar (ANS), instituição que regula as
                                        atividades das operadoras de planos privados de assistência à saúde, e tem como
                                        missão defender o interesse público vem, por meio desta, prestar informações
                                        para o preenchimento da DECLARAÇÃO DE SAÚDE.
                                      </p>
                                    </div>
                                    <div class="row">
                                      <h5 class="mt-2 mb-1">
                                        <strong>O QUE É DECLARAÇÃO DE SAÚDE?</strong>
                                      </h5>
                                      <p>
                                        É o formulário que acompanha o Contrato do Plano de Saúde, onde o beneficiário
                                        ou seu representante legal deverá informar doenças ou lesões preexistentes que
                                        saiba ser portador ou sofredor no momento da contratação do plano. Para o seu
                                        preenchimento, o beneficiário tem o direito de ser orientado, gratuitamente, por
                                        um médico credenciado/referenciado pela operadora. Se optar por um profissional
                                        de sua livre escolha, assumirá o custo desta opção.
                                      </p>
                                      <p>
                                        Portanto, se o beneficiário (você) toma medicamentos regularmente, consulta
                                        médicos por problema de saúde do qual conhece o diagnóstico, fez qualquer exame
                                        que identificou alguma doença ou lesão, esteve internado ou submeteu-se a alguma
                                        cirurgia, DEVE DECLARAR ESTA DOENÇA OU LESÃO.
                                      </p>
                                      <h5 class="mt-3 mb-1">
                                        <strong>
                                          AO DECLARAR AS DOENÇAS E/ OU LESÕES QUE O BENECIFIÁRIO SAIBA SER PORTADOR NO
                                          MOMENTO DA CONTRATAÇÃO.
                                        </strong>
                                      </h5>
                                      <ul>
                                        <li>
                                          A operadora NÃO poderá impedi-lo de contratar o plano de saúde. Caso isto
                                          ocorra, encaminhe a denúncia à ANS.
                                        </li>
                                        <li>
                                          A operadora deverá oferecer: cobertura total ou COBERTURA PARCIAL TEMPORÁRIA
                                          (CPT), podendo ainda oferecer o Agravo, que é um acréscimo no valor da
                                          mensalidade, pago ao plano privado de assistência à saúde, para que possa
                                          utilizar toda a cobertura contratada, após os prazos de carências contratuais.
                                        </li>
                                        <li>
                                          No caso de CPT, haverá restrição de cobertura para cirurgias, leitos de alta
                                          tecnologia (UTI, unidade coronáriana ou neonatal), e procedimentos de alta
                                          complexidade - PAC (tomografia, ressonância, etc.*), EXCLUSIVAMENTE
                                          relacionados à doença ou lesão declarada, até 24 meses, contados desde a
                                          assinatura do contrato. Após o período máximo de 24 meses da assinatura
                                          contratual, a cobertura passará a ser integral, de acordo com o plano
                                          contratado.
                                        </li>
                                        <li>
                                          NÃO haverá restrição de cobertura para consultas médicas, internações não
                                          cirúrgicas, exames e procedimentos que não sejam de alta complexidade, mesmo
                                          que relacionados à doença ou lesão preexistente declarada, desde que cumpridos
                                          os prazos de carências estabelecidas no contrato.
                                        </li>
                                        <li>
                                          Não caberá alegação posterior de omissão de informação na Declaração de Saúde
                                          por parte da operadora para esta doença ou lesão.
                                        </li>
                                      </ul>
                                      <h5 class="mt-3 mb-1">
                                        <strong>
                                          AO NÃO DECLARAR AS DOENÇAS E/ OU LESÕES QUE O BENEFICIÁRIO SAIBA SER PORTADOR
                                          NO MOMENTO DA CONTRATAÇÃO:
                                        </strong>
                                      </h5>
                                      <ul>
                                        <li>
                                          A operadora poderá suspeitar de omissão de informação e, neste caso, deverá
                                          comunicar imediatamente ao beneficiário, podendo oferecer CPT, ou solicitar
                                          abertura de processo administrativo junto à ANS, denunciando a omissão da
                                          informação.
                                        </li>
                                        <li>
                                          Comprovada a omissão de informação pelo beneficiário, a operadora poderá
                                          RESCINDIR o contrato por FRAUDE e responsabilizá-lo pelos procedimentos
                                          referentes à doença ou lesão não declarada.
                                        </li>
                                        <li>
                                          Até o julgamento final do processo pela ANS, NÃO poderá ocorrer suspensão do
                                          atendimento nem rescisão do contrato. Caso isto ocorra, encaminhe a denúncia à
                                          ANS.
                                        </li>
                                      </ul>
                                    </div>
                                    <div class="row mt-1">
                                      <p>
                                        ATENÇÃO! Se a operadora oferecer redução ou isenção de carência, isto não
                                        significa que dará cobertura assistencial para as doenças ou lesões que o
                                        beneficiário saiba ter no momento da assinatura contratual. Cobertura Parcial
                                        Temporária - CPT - NÃO É CARÊNCIA! Portanto, o beneficiário não deve deixar de
                                        informar se possui alguma doença ou lesão, ao preencher a Declaração de Saúde!
                                      </p>
                                      <p class="mt-1">
                                        *Para consultar a lista completa de procedimentos de alta complexidade - PAC
                                        acesse o Rol de Procedimentos e Eventos em Saúde da ANS, no endereço eletrônico:
                                        <a href="https://www.ans.gov.br" target="_blank" rel="noopener noreferrer">
                                          www.ans.gov.br
                                        </a>
                                        - Perfil Beneficiário. Em caso de Dúvidas, entre em contato com a ANS pelo
                                        telefone 0800-701-9656 ou consulte a página da ANS -
                                        <a href="https://www.ans.gov.br" target="_blank" rel="noopener noreferrer">
                                          www.ans.gov.br
                                        </a>
                                        - Perfil Beneficiário.
                                      </p>
                                      <div class="row assinatura-pag ass-carta">
                                        <div class="columm wide">
                                          <div class="row">
                                            <div class="columm wide">
                                              <div class="row">
                                                <div
                                                  class="column col-xs-5 col-sm-5 col-md-5 col-lg-5 strong contratante pull-left"></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
                <!-- Buttons -->
                <div class="button-mobile d-flex justify-content-end w-100 mt-2">
                  <button
                    (click)="concordarCartaOrientacao()"
                    class="btn-simule btn btn-outline-secondary btn-min-width">
                    De Acordo
                  </button>
                </div>
              </mat-step>
              <!-- passo 6 - Perguntas -->
              <mat-step [label]="'PERGUNTAS ' + propostaEnum.PERGUNTAS">
                <div class="card-header card-form-header mt-1">
                  <!-- Fomulário do Titular -->
                  <div class="card" style="margin-bottom: 1rem">
                    <app-perguntas-declaracao-saude
                      [nome]="nome"
                      [idade]="idade"
                      [ehMasculino]="ehMasculino"
                      [qtdPerguntasFormAtual]="this.limitePerguntas"
                      [listaDeBeneficiarios]="listaDeBeneficiario"
                      [currentQuestionIndex]="ultimaPerguntaRespondidaCodigo"
                      [ultimaPerguntaRespondida]="ultimaPerguntaRespondida"
                      [listaDeRespostasBeneficiarios]="respostasOrganizadaPorBeneficiario"
                      [somenteLeituraStep]="somenteLeituraStep"></app-perguntas-declaracao-saude>
                  </div>
                  <!-- Botões -->
                  <div class="button-mobile d-flex justify-content-between w-100 mt-3">
                    <ng-container *ngIf="!ocultarBtn(); else spanPlaceholder">
                      <button (click)="voltarPerguntasOuStep()" class="btn-simule btn btn-outline-secondary">
                        <i class="fa fa-arrow-left"></i>
                        Voltar
                      </button>
                    </ng-container>

                    <ng-template #spanPlaceholder>
                      <span></span>
                    </ng-template>
                    <button (click)="validarResposta()" class="btn-simule btn btn-outline-secondary">
                      Avançar
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </mat-step>
              <!-- passo 7 -->
              <mat-step [label]="'TERMO ' + propostaEnum.TERMO">
                <div class="card-header card-form-header mt-1">
                  <!-- Fomulário do Titular -->
                  <div class="card" style="margin-bottom: 1rem">
                    <h3 class="text-center form-section">
                      <b>Termo de consentimento sobre o questionário preenchido</b>
                    </h3>
                    <div class="col-md-12 col-sm-12 mt-1">
                      <p class="preto-geia">
                        Havendo declaração de doenças ou lesões preexistentes e tendo sido orientado, estou ciente da
                        Cobertura Parcial Temporária (CPT) – período ininterrupto de 24 meses em que estará suspensa a
                        cobertura de Procedimentos de Alta Complexidade (PAC), leitos de alta tecnologia e procedimentos
                        cirúrgicos relacionados às doenças e lesões pré-existentes.
                      </p>
                    </div>
                    <div class="col-md-12 col-sm-12 mt-1">
                      <p class="preto-geia">
                        Eu,
                        <b>{{ nome }}</b>
                        , declaro ainda que:
                      </p>
                    </div>
                    <div class="card-content col-md-12 col-sm-12 mt-1">
                      <form [formGroup]="formDeclaracaoSaude">
                        <div class="form-group mb-1 col-sm-12 col-md-12">
                          <div class="row">
                            <label style="cursor: pointer">
                              <input
                                (ngModelChange)="onFieldChange()"
                                formControlName="optionForPreExistingIllnesses"
                                [attr.disabled]="somenteLeituraStep ? '' : null"
                                [attr.readonly]="somenteLeituraStep ? '' : null"
                                [value]="1"
                                id="active"
                                type="radio"
                                class="input-radio off"
                                name="optionForPreExistingIllnesses" />
                              &nbsp;&nbsp; Fui orientado por médico cooperado à UNIMED FESP no preenchimento da
                              declaração de saúde;
                            </label>
                          </div>
                          <div class="row">
                            <label style="cursor: pointer">
                              <input
                                (ngModelChange)="onFieldChange()"
                                formControlName="optionForPreExistingIllnesses"
                                [attr.disabled]="somenteLeituraStep ? '' : null"
                                [attr.readonly]="somenteLeituraStep ? '' : null"
                                [value]="2"
                                id="Inactive"
                                type="radio"
                                class="input-radio on"
                                name="optionForPreExistingIllnesses" />
                              &nbsp;&nbsp; Fui orientado por um médico particular, no preenchimento da declaração de
                              saúde, arcando com o ônus da consulta;
                            </label>
                          </div>
                          <div class="row">
                            <label style="cursor: pointer">
                              <input
                                (ngModelChange)="onFieldChange()"
                                formControlName="optionForPreExistingIllnesses"
                                [attr.disabled]="somenteLeituraStep ? '' : null"
                                [attr.readonly]="somenteLeituraStep ? '' : null"
                                [value]="3"
                                id="Inactive"
                                type="radio"
                                class="input-radio on"
                                name="optionForPreExistingIllnesses" />
                              &nbsp;&nbsp; Entendi o conteúdo de todas as perguntas da declaração de saúde e dispensei a
                              orientação médica para respondê-las, assumindo total responsabilidade pelas informações
                              por mim prestadas.
                            </label>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- Botões -->
                  <div class="button-mobile d-flex justify-content-between w-100 mt-3">
                    <button
                      (click)="voltarPerguntasOuStep(propostaEnum.TERMO)"
                      class="btn-simule btn btn-outline-secondary">
                      <i class="fa fa-arrow-left"></i>
                      Voltar
                    </button>

                    <button (click)="termoQuestionarioPreenchido()" class="btn-simule btn btn-outline-secondary">
                      Avançar
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </mat-step>
              <!-- passo 8 - Questionário da Declaração de Saúde-->
              <mat-step [label]="'QUESTIONARIO ' + propostaEnum.QUESTIONARIO">
                <div class="card-header card-form-header mt-1">
                  <div class="card mb-5">
                    <h3 class="text-center form-section">
                      <b>Questionário da Declaração de Saúde</b>
                    </h3>
                  </div>
                  <!-- Para Titular (quando dependentInclusion = false) -->
                  <div *ngFor="let item of listaDeBeneficiario">
                    <div *ngIf="!item.isDependent && !dependentInclusion">
                      <!-- Se preenchido -->
                      <div
                        *ngIf="item.preenchido"
                        class="alert round bg-success alert-icon-left alert-dismissible mb-2 box-shadow-4"
                        role="alert"
                        style="cursor: pointer"
                        (click)="voltarPerguntasOuStep(propostaEnum.PERGUNTAS, item)">
                        <span class="alert-icon"><i class="fa fa-check"></i></span>
                        Questionário já respondido - TITULAR:
                        <strong>{{ item.name }}</strong>
                      </div>

                      <!-- Se não preenchido -->
                      <div
                        *ngIf="!item.preenchido"
                        class="alert round bg-warning alert-icon-left alert-dismissible mb-2 box-shadow-4"
                        role="alert"
                        style="cursor: pointer"
                        (click)="voltarPerguntasOuStep(propostaEnum.PERGUNTAS, item)">
                        <span class="alert-icon"><i class="fa fa-exclamation"></i></span>
                        <strong>Atenção!</strong>
                        É necessário responder as perguntas do TITULAR:
                        <br />
                        <strong>{{ item.name }}</strong>
                      </div>
                    </div>
                  </div>

                  <!-- Dependentes - SEMPRE visível -->
                  <div *ngFor="let item of listaDeBeneficiario">
                    <div *ngIf="item.isDependent">
                      <!-- Se preenchido -->
                      <div
                        *ngIf="item.preenchido"
                        class="alert round bg-success alert-icon-left alert-dismissible mb-2 box-shadow-4"
                        role="alert"
                        style="cursor: pointer"
                        (click)="voltarPerguntasOuStep(propostaEnum.PERGUNTAS, item)">
                        <span class="alert-icon"><i class="fa fa-check"></i></span>
                        Questionário já respondido - DEPENDENTE :
                        <strong>{{ item.name }}</strong>
                      </div>

                      <!-- Se não preenchido -->
                      <div
                        *ngIf="!item.preenchido"
                        class="alert round bg-warning alert-icon-left alert-dismissible mb-2 box-shadow-4"
                        role="alert"
                        style="cursor: pointer"
                        (click)="voltarPerguntasOuStep(propostaEnum.PERGUNTAS, item)">
                        <span class="alert-icon"><i class="fa fa-exclamation"></i></span>
                        <strong>Atenção!</strong>
                        É necessário responder as perguntas do DEPENDENTE:
                        <br />
                        <strong>{{ item.name }}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Botões -->
                <div class="button-mobile d-flex justify-content-between w-100 mt-3">
                  <span></span>
                  <button (click)="onFinalizarDeclaracaoSaude()" class="btn-simule btn btn-outline-secondary">
                    Próximo
                    <i class="fa fa-arrow-right"></i>
                  </button>
                </div>
              </mat-step>
              <!-- passo 13 - Perguntas -->
              <mat-step [label]="'RETORNO_DS ' + propostaEnum.RETORNO_DS">
                <div class="card-header card-form-header mt-1">
                  <!-- Fomulário do Titular -->
                  <div class="card" style="margin-bottom: 1rem">
                    <app-perguntas-declaracao-saude
                      (concluirRetornoDS)="finalizarRetornoDS($event)"></app-perguntas-declaracao-saude>
                  </div>
                  <div class="button-mobile d-flex justify-content-between w-100 mt-3" *ngIf="perguntaRetornada">
                    <ng-container *ngIf="!ocultarBtnVoltarRetornoDS(); else spanPlaceholder">
                      <button (click)="voltarPerguntaRetornoDS()" class="btn-simule btn btn-outline-secondary">
                        <i class="fa fa-arrow-left"></i>
                        Voltar
                      </button>
                    </ng-container>

                    <ng-template #spanPlaceholder>
                      <span></span>
                    </ng-template>
                    <button class="btn-simule btn btn-outline-secondary" (click)="avancarPerguntaRetornoDS()">
                      <ng-container *ngIf="!concluirRetornoDS; else concluirRetornoDSBtn">Avançar</ng-container>
                      <ng-template #concluirRetornoDSBtn>Concluir</ng-template>
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </ng-container>
          <!-- Área do Colaborador -->
          <ng-container *ngIf="heColaborador">
            <app-proposta-declaracao-saude-colaborador></app-proposta-declaracao-saude-colaborador>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
  <!-- Modal Retorno DS -->
  <ng-template #templateModal>
    <app-modal-simples [title]="titleModal" (cancel)="fecharModal(); modalRef.hide()">
      <div class="modal-body">
        <div class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <a style="text-decoration: none">
              <img
                alt="logo"
                border="0"
                height="45"
                src="https://geia.com.br/assets/app-assets/images/logo/logo-b-geia.png"
                style="
                  display: block;
                  font-family: 'Montserrat';
                  font-size: 15px;
                  line-height: 25px;
                  color: #000000;
                  max-width: 156px;
                "
                width="110" />
            </a>
          </div>
        </div>
        <div class="row card-content">
          <div class="card-body" style="padding: 1rem">
            <div class="card-header card-form-header d-flex justify-content-center align-items-center mb-1">
              <h5 class="form-section">
                <span style="color: #55595c">
                  Prezado(a)
                  <b>{{ nome }}</b>
                </span>
              </h5>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <span>
                  Durante nossa auditoria de saúde, identificamos algumas informações de saúde que não haviam sido
                  declaradas anteriormente.
                </span>
                <span>
                  Nossa equipe já realizou as devidas correções para garantir que tudo esteja em conformidade.
                </span>
                <span>A seguir, segue a análise atualizada para sua revisão.</span>
                <span>
                  Caso tenha qualquer dúvida ou precise de esclarecimentos, estamos a disposição para ajudá-lo(a).
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form-actions float-right d-flex justify-content-end align-items-lg-end mb-1"
          style="text-align: right">
          <button
            data-dismiss="modal"
            (click)="fecharModal(); modalRef.hide()"
            type="button"
            class="btn cursor-pointer btn-round btn-success-geia white btn-min-width box-shadow-4">
            <i class="ft-x"></i>
            Avançar
          </button>
        </div>
      </div>
    </app-modal-simples>
  </ng-template>

  <!-- Modal da Cancelamento Plano Anterior -->
  <ng-template #modalCancelamentoPlanoAnterior let-modal>
    <div class="modal-body">
      <!-- Conteúdo da Súmula 21  -->
      <div class="card-content">
        <div class="card-body">
          <h4 class="modal-title p-1 text-center" style="background: black; color: #fff">
            DECLARAÇÃO DE CIÊNCIA DE CANCELAMENTO PLANO ANTERIOR
          </h4>

          <p class="mt-1">
            Eu {{ nomeModalCancelamento }} portador do CPF: {{ cpf | cpf }}, declaro estar ciente que necessito efetuar
            o cancelamento do plano anterior
            <b>5 dias após seu início no novo plano de destino.</b>
          </p>
          <div class="row" style="background: #fff; border-radius: 5px">
            <div class="mb-1 mt-2">
              <input
                [(ngModel)]="checkboxSumula"
                id="checkboxSumula21"
                type="checkbox"
                (click)="fecharModalCancelamento()" />
              <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxSumula21">
                Li e estou ciente do cancelamento.
                <a class="ml-1"></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
